<template>
    <div>
        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="panel-tag mt-3" v-if="!isSpinnerShow && Object.keys(orderItems).length == 0">
            {{ $t('table.no_records') }}
        </div>
        <div v-if="!isSpinnerShow && Object.keys(orderItems).length != 0" class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table
                           class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline"
                           role="grid"
                           style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">
                                    {{ tblHeader.label }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, k) in orderItems" :key="k">
                                <td class="align-middle">{{ k + 1 }}</td>
                                <td class="align-middle">
                                    {{ convertTimestampToDate(item.createDate) }}
                                    <br>
                                    {{ convertTimestampToTime(item.createDate) }}
                                </td>
                                <td class="align-middle">
                                    <a
                                       class="fw-400 text-primary link"
                                       title="View Receipt"
                                       @click="generateReceipt(item.saleID)">
                                        {{ insertLeadingZero(item.receiptID) }}
                                        <i class="fal fa-print"></i>
                                    </a>
                                </td>
                                <td class="align-middle">
                                    <div class="font-weight-bold">{{ item.memberName }}</div>
                                    <div class="align-middle">
                                        <span class="badge badge-pill badge-success"><i class="fas fa-phone"></i></span>
                                        {{ item.memberMobile }}
                                    </div>
                                </td>
                                <td class="align-middle">
                                    <div class="font-weight-bold" v-if="item.address.line1">{{ item.address.line1 }}</div>
                                    <div v-if="item.address.line2">{{ item.address.line2 }}</div>
                                    <div v-if="item.address.postalCode">{{ item.address.postalCode }}</div>
                                    <div v-if="item.address.city">{{ item.address.city }}</div>
                                </td>
                                <td class="align-middle">
                                    <div v-for="(product, l) in item.items" :key="item.saleID + '_' + l">
                                        {{ product['quantity'] }} - {{ product['title'] }}
                                    </div>
                                </td>
                                <td class="align-middle" @click="onStatusClick(item)">
                                <!-- <td class="align-middle"> -->
                                    <!-- <multiselect
                                        v-model="item.status"
                                        :options="actions"
                                        :searchable="false"
                                        :showLabels="false"
                                        :close-on-select="true" 
                                        @select="onStatusChange">
                                        <template slot="tag" slot-scope="{ option }">
                                            <span v-if="option === 'New'" class="badge badge-danger">{{ getStatusLocalized('label.new') }}</span>
                                            <span v-if="option === 'Delivery'" class="badge badge-warning">{{ getStatusLocalized('label.delivery') }}</span>
                                            <span v-if="option === 'Packaged'" class="badge badge-primary">{{ getStatusLocalized('label.packaged') }}</span>
                                            <span v-if="option === 'Delivered'" class="badge badge-success">{{ getStatusLocalized('label.delivered') }}</span>
                                        </template>
                                        <template slot="option" slot-scope="{ option }">
                                            <span v-if="option === 'New'" class="badge badge-danger">{{ getStatusLocalized('label.new') }}</span>
                                            <span v-if="option === 'Delivery'" class="badge badge-warning">{{ getStatusLocalized('label.delivery') }}</span>
                                            <span v-if="option === 'Packaged'" class="badge badge-primary">{{ getStatusLocalized('label.packaged') }}</span>
                                            <span v-if="option === 'Delivered'" class="badge badge-success">{{ getStatusLocalized('label.delivered') }}</span>
                                        </template>
                                    </multiselect> -->
                                    <span v-if="item.status === 'New'" class="badge badge-danger">{{ getStatusLocalized('label.new') }}</span>
                                    <span v-if="item.status === 'Delivery'" class="badge badge-warning">{{ getStatusLocalized('label.delivery') }}</span>
                                    <span v-if="item.status === 'Packaged'" class="badge badge-primary">{{ getStatusLocalized('label.packaged') }}</span>
                                    <span v-if="item.status === 'Delivered'" class="badge badge-success">{{ getStatusLocalized('label.delivered') }}</span>
                                    <br>
                                    <div v-if="item.date">
                                        {{ convertTimestampToDate(item.date) }}
                                        <br>
                                        {{ convertTimestampToTime(item.date) }}
                                    </div>
                                </td>
                                <td class="align-middle">
                                    <b-button @click="showModal(item)" tabindex="0" variant="outline-primary">
                                        <i class="fal fa-pencil fs-xl"></i>
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <deliveryForm ref="modalForm" @onModalClose="onModalClose"></deliveryForm>
        <deliveryStatusForm ref="deliveryStatusForm" @onModalClose="onDeliveryModalClose"></deliveryStatusForm>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import tbl from './../../../../assets/js/dashboard/table-header'
import exp from './../../../../assets/js/dashboard/export-table-header'
import { insertLeadingZero } from './../../../../assets/js/dashboard/utilities.js'
import { getOutletName, handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import { formatPrice } from './../../../../assets/js/dashboard/utilities'
import DeliveryForm from './Delivery_Form'
import DeliveryStatusForm from './Delivery_StatusForm'


export default {
    name: 'deliveryList',
    components: {
        DeliveryForm,
        DeliveryStatusForm,
    },
    data() {
        return {
            actions: [
                'New',
                'Delivery',
                'Packaged',
                'Delivered',
            ],

            tblHeaders: tbl.orderTblHdr,
            orderItems: {}, outlet: [], isSpinnerShow: false,
            salesID: "", mobile: "",
            filterObj: {},

            modalShow: false,
        }
    },
    computed: {
        fields() {
            var fArr = []
            if (this.filterObj.itemType != 'all') {
                fArr.push({ key: "index", label: '#', thClass: 'thead-themed align-middle' })
            }
            var arr = [
                { key: "time", label: this.$i18n.t('table.header.time') },
                { key: "receipt", label: this.$i18n.t('table.header.receipt_no') },
                { key: "customer", label: this.$i18n.t('table.header.customer') },
                { key: "address", label: this.$i18n.t('table.header.address') },
                { key: "items", label: this.$i18n.t('table.header.items') },
                { key: "status", label: this.$i18n.t('table.header.delivery_status') },
                // { key: "deliveryDate", label: this.$i18n.t('table.header.delivery_date') },
                // { key: "packageDate", label: this.$i18n.t('table.header.packaged_date') },
                // { key: "deliveredDate", label: this.$i18n.t('table.header.delivered_date') },
                { key: "action", label: this.$i18n.t('table.action') },
            ]
            fArr.push(...arr)
            return fArr
        },
        exportFields() {
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.time')).toUpperCase()] = "date"
            ret[(this.$i18n.t('table.header.receipt_no')).toUpperCase()] = "receipt"
            ret[(this.$i18n.t('table.header.customer')).toUpperCase()] = "customer"
            ret[(this.$i18n.t('table.header.contact')).toUpperCase()] = "mobile"
            ret[(this.$i18n.t('table.header.address1')).toUpperCase()] = "address1"
            ret[(this.$i18n.t('table.header.address2')).toUpperCase()] = "address2"
            ret[(this.$i18n.t('table.header.postal_code')).toUpperCase()] = "postalCode"
            ret[(this.$i18n.t('table.header.city')).toUpperCase()] = "city"
            ret[(this.$i18n.t('table.header.items')).toUpperCase()] = "items"
            ret[(this.$i18n.t('table.header.delivery_status')).toUpperCase()] = "status"
            ret[(this.$i18n.t('table.header.delivery_date')).toUpperCase()] = "deliveryDate"
            ret[(this.$i18n.t('table.header.packaged_date')).toUpperCase()] = "packageDate"
            ret[(this.$i18n.t('table.header.delivered_date')).toUpperCase()] = "deliveredDate"
            return ret
        },
    },
    watch: {
        "$i18n.locale"(val) {
            this.setExportData(this.orderItems, this.filterObj)
        }
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price);
        },
        convertTimestampToDate(date) {
            return moment(date * 1000).format(this.$msg.CST.DATE_FORMAT);
        },
        convertTimestampToTime(date) {
            return moment(date * 1000).format(this.$msg.CST.TIME_FORMAT_24);
        },
        getStatusLocalized(t) {
            return this.$i18n.t(t) || t
        },
        getOutletName(id) {
            return getOutletName(id, this.outlet)
        },
        insertLeadingZero(number) {
            return insertLeadingZero(number);
        },
        getDateTime(ts) {
            return moment(ts * 1000).format('DD/MM/YYYY HH:mm:ss')
        },

        setCity(city) {
            this.$refs.modalForm.setCity(city)
        },

        setOrderItems(items, filterObj) {
            this.isSpinnerShow = false;
            this.orderItems = items
            this.filterObj = filterObj
            this.setExportData(this.orderItems, filterObj)
        },
        setExportData(group, filterObj) {
            var exportData = []
            for (var k = 0; k < group.length; k++) {
                group[k].address = group[k].address || {}

                let item = ''
                for (let product of group[k]['items']) {
                    item += `${product['quantity']} - ${product['title']}\n`
                }

                var obj = {
                    index: k + 1,
                    date: this.getDateTime(group[k].createDate),
                    receipt: this.insertLeadingZero(group[k].receiptID),
                    customer: group[k]['memberName'],
                    mobile: group[k]['memberMobile'],
                    address1: group[k].address.line1 || '',
                    address2: group[k].address.line2 || '',
                    postalCode: group[k].address.postalCode || '',
                    city: group[k].address.city || '',
                    items: item,
                    deliveryDate: group[k].deliveryDate ? this.getDateTime(group[k].deliveryDate) : '',
                    packageDate: group[k].deliveryDate ? this.getDateTime(group[k].packageDate) : '',
                    deliveredDate: group[k].deliveryDate ? this.getDateTime(group[k].deliveredDate) : '',
                    status: group[k]['status'],
                }

                exportData.push(obj)
            }

            var strDate = moment(filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_delivery`)
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_delivery`),
                this.$i18n.t('table.header.date') + ": " + strDate,
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                this.$i18n.t('label.outlet') + ": " + (filterObj.outlet.id == "all" ? this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) : filterObj.outlet.text),
                " "];
            var exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV

            var data = {
                exportData: exportData,
                exportHeaders: exportHeaders,
                exportFileName: exportFileName,
                exportFields: this.exportFields
            }
            this.$emit('setExportData', data)
        },

        generateReceipt(salesID) {
            const QUERY_STRING = "/" + salesID + this.$api.RECEIPT
            const url = this.$api.REPORT_SALES + QUERY_STRING;

            let $vm = this
            this.$axios({
                method: 'get',
                url: url,
                baseURL: this.$axios.defaults.baseURL,
                headers: { token: this.$util.getSessionToken() }
            })
                .then(function (response) {
                    if (response.status == 200) {
                        var path = response.data.path;
                        window.open(path, '_blank');
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        showModal(item) {
            this.$refs.modalForm.setData(item);
        },
        onStatusClick(item) {
            // if(item['status'] === 'Delivered') {
            //     return
            // }
            
            this.$refs.deliveryStatusForm.setData(item, true);
        },
        onModalClose(){
            this.$emit('onModalClose')
        },
        onDeliveryModalClose() {
            this.$emit('onModalClose')
        },
    },
    mounted() {
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
    }
}
</script>
<style scoped>
.show{
    display: block;
}
</style>
<style>
.nav-link, .link{
    cursor: pointer;
}

.link > i {
    font-size: large;
}
.modal-body{
    max-height: 65vh;
    overflow-y: auto;
}
.modal-lg{
    max-width: 1000px;
}

.width-12{
    width: 12%;
}
</style>